import { RouteConfig, Route } from 'vue-router';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import AppStoreModule from '../store/modules/AppStoreModule';
import AppModule from '../types/base/AppModule';

const appStore: AppStoreModule = getStoreModule(AppStoreModule);

export async function getRoutes(): Promise<RouteConfig[]> {
	const routes: RouteConfig[] = [
		{
			path: `/share/:id/:locale([a-zA-Z\\-]{2,5})?/:chapterId?/:deeplink*`,
			name: 'share',
			component: (): any => import('@modules/share/ShareModule.vue'),
			beforeEnter: (to: Route, from: Route, next: (route?: any) => void): void => {
				appStore.setActiveAppModule(AppModule.Share);
				next();
			},
			children: []
		}
	];

	return routes;
}
